import React from 'react';
import { ENV } from 'config/config';
import { Button, Form, Container, Row, Col, OverlayTrigger, Modal, FormGroup } from "react-bootstrap";
const { formatUrl, formatMetaKeywords, integerNumberValidator } = ENV

const DocumentModal = ({ modalCloseHandler, setDocument, openModal, submit, documentErrors, setDocumentErrors }) => {

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const acceptedExtensions = ['.pdf', '.doc', '.docx', '.odt', '.xls', '.xlsx', '.ods', '.ppt', '.pptx', '.txt', '.csv'];
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            if (!acceptedExtensions.includes(fileExtension)) {
                setDocumentErrors('Invalid file extension. Please select a valid file.\nValid file extentions are: .pdf, .doc, .docx, .odt, .xls, .xlsx, .ods, .ppt, .pptx, .txt, .csv');
                e.target.value = null; // Deselect the file
                setDocument(null); // Clear the document state
            } else {
                setDocument(file); // Update the document state with the selected file
            }
        }
    };

    return (
        <Container fluid>
            {
                openModal &&
                <Modal className="modal-primary edit-cotnact-modal" onHide={modalCloseHandler} show={openModal}>
                    <Modal.Header className="justify-content-center">
                        <Row>
                            <div className="col-12">
                                <h4 className="mb-0 mb-md-3 mt-0">
                                    Add Document
                                </h4>
                            </div>
                        </Row>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="text-left">
                            <Form.Group>
                                <label className=''>Document <span className="text-danger">*</span> </label>
                                <Form.Control
                                    className=""
                                    placeholder="Document"
                                    type="file"
                                    varient="info"
                                    accept=".pdf,.doc,.docx,,.odt,.xls,.xlsx,.ods,.ppt,.pptx.txt,.csv"
                                    onChange={(e) => onFileChange(e)}
                                    id="document"
                                />
                                <span className={documentErrors !== '' ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{documentErrors}</label>
                                </span>

                            </Form.Group>

                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className="outline-button" onClick={modalCloseHandler}>Close</Button>
                        <Button className="btn-filled"
                            onClick={submit}
                        >
                            Submit
                        </Button>


                    </Modal.Footer>
                </Modal>
            }
        </Container >
    )
}

export default DocumentModal;